import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { analyticsTrack } from '../../analyticsUtils';
import { getRequest } from '../../requestUtils';
import NavBar from './NavBar';
import ProjectDetailsNav from './ProjectDetailsNav';
import ProjectName from './ProjectName';
import ProjectExpertise from './ProjectExpertise';
import ProjectExpertisePriority from './ProjectExpertisePriority';
import ProjectScope from './ProjectScope';
import ProjectResponsibilities from './ProjectResponsibilities';
import ProjectBudgetLogistics from './ProjectBudgetLogistics';
import ProjectReview from './ProjectReview';
import FeaturedProfileBanner from './FeaturedProfileBanner';
import './ProjectDetails.scss';
var capitalize = function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
var ProjectDetails = /*#__PURE__*/function (_Component) {
  function ProjectDetails(props) {
    var _this;
    _classCallCheck(this, ProjectDetails);
    _this = _callSuper(this, ProjectDetails, [props]);
    _this.state = {
      steps: ['start', 'description', 'qualifications', 'expertise-priority', 'budget & logistics', 'review'],
      step: props.step,
      validatedStep: props.validatedStep || 'review',
      projectResourceId: props.projectResourceId,
      fromReviewPage: false
    };
    _this.getProjectDetails = _this.getProjectDetails.bind(_this);
    _this.handleUpdateSection = _this.handleUpdateSection.bind(_this);
    _this.handleSetProjectResourceId = _this.handleSetProjectResourceId.bind(_this);
    _this.handleReturnToProjectPage = _this.handleReturnToProjectPage.bind(_this);
    return _this;
  }
  _inherits(ProjectDetails, _Component);
  return _createClass(ProjectDetails, [{
    key: "getProjectDetails",
    value: function getProjectDetails() {
      var formStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var projectResourceId = this.state.projectResourceId;
      if (projectResourceId) {
        return getRequest("/projects/".concat(projectResourceId, "?form_step=").concat(formStep));
      }
      return {};
    }
  }, {
    key: "getButtonProps",
    value: function getButtonProps() {
      var _this$state = this.state,
        fromReviewPage = _this$state.fromReviewPage,
        step = _this$state.step,
        steps = _this$state.steps;
      var returnToProjectPage = this.props.returnToProjectPage;
      var currentStepIndex = steps.indexOf(step);
      if (fromReviewPage) {
        var after = step === 'qualifications' ? this.handleUpdateSection('expertise-priority', true) : this.handleUpdateSection('review');
        return {
          afterSubmit: after,
          back: this.handleUpdateSection('review'),
          backButtonText: 'Cancel',
          submitButtonText: 'Save'
        };
      }
      if (returnToProjectPage) {
        var _after = step === 'qualifications' ? this.handleUpdateSection('expertise-priority', false) : this.handleReturnToProjectPage;
        var back = step === 'expertise-priority' ? this.handleUpdateSection('qualifications', false) : this.handleReturnToProjectPage;
        var submitButtonText = step === 'qualifications' ? 'Next' : 'Save';
        var backButtonText = step === 'expertise-priority' ? 'Back' : 'Cancel';
        return {
          afterSubmit: _after,
          back: back,
          backButtonText: backButtonText,
          submitButtonText: submitButtonText
        };
      }
      if (currentStepIndex === 0 && this.props.duplicationProjectResourceId) {
        return {
          afterSubmit: this.handleUpdateSection('review'),
          back: function back() {
            return history.back();
          },
          backButtonText: 'Back',
          submitButtonText: 'Save'
        };
      }
      if (currentStepIndex === steps.length - 1) {
        return {};
      }
      var goBack = currentStepIndex === 0 ? function () {
        return history.back();
      } : this.handleUpdateSection(steps[currentStepIndex - 1]);
      var nextSection = steps[currentStepIndex + 1];
      var goNext = this.handleUpdateSection(nextSection);
      return {
        afterSubmit: goNext,
        back: goBack,
        backButtonText: 'Back',
        submitButtonText: step === 'qualifications' ? 'Next' : "Next: ".concat(capitalize(nextSection))
      };
    }
  }, {
    key: "handleReturnToProjectPage",
    value: function handleReturnToProjectPage() {
      var projectResourceId = this.props.projectResourceId;
      window.location.href = "/projects/".concat(projectResourceId);
    }
  }, {
    key: "handleSetProjectResourceId",
    value: function handleSetProjectResourceId(callback) {
      var _this2 = this;
      return function (projectResourceId) {
        _this2.setState({
          projectResourceId: projectResourceId
        }, callback);
      };
    }
  }, {
    key: "handleUpdateSection",
    value: function handleUpdateSection(nextStep) {
      var _this3 = this;
      var fromReviewPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var steps = this.state.steps;
      var _this$props = this.props,
        userId = _this$props.userId,
        newProjectDetails = _this$props.newProjectDetails;
      return function () {
        var _this3$state = _this3.state,
          validatedStep = _this3$state.validatedStep,
          step = _this3$state.step,
          projectResourceId = _this3$state.projectResourceId;
        var nextOrBack = steps.indexOf(nextStep) > steps.indexOf(step);
        var newValidatedStep = steps.indexOf(nextStep) > steps.indexOf(validatedStep) ? nextStep : validatedStep;
        analyticsTrack("Clicked next from ".concat(step, " section"), {
          location: 'Project creation',
          eventId: nextOrBack ? "next-click-".concat(step) : "back-click-".concat(step),
          eventType: 'buttonClick',
          timestamp: Date.now(),
          buttonId: nextOrBack ? "next-button-".concat(step) : "back-button-".concat(step),
          buttonLabel: nextOrBack ? "Next: ".concat(nextStep) : "Back: ".concat(nextStep),
          wizardStep: nextOrBack ? steps.indexOf(step) + 2 : steps.indexOf(step),
          wizardTotalSteps: steps.length,
          userId: userId
        });
        _this3.setState({
          validatedStep: newValidatedStep,
          step: nextStep,
          fromReviewPage: fromReviewPage
        });
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
        if (projectResourceId) {
          window.history.pushState(null, newProjectDetails.name, "/projects/".concat(projectResourceId, "/edit?step=").concat(nextStep));
        }
      };
    }
  }, {
    key: "renderNameSection",
    value: function renderNameSection() {
      var _this$props2 = this.props,
        projectUrl = _this$props2.projectUrl,
        csrfToken = _this$props2.csrfToken,
        isAdmin = _this$props2.isAdmin,
        companyPicklist = _this$props2.companyPicklist,
        companyId = _this$props2.companyId,
        projectName = _this$props2.projectName,
        duplicationProjectResourceId = _this$props2.duplicationProjectResourceId,
        rehireUserResourceId = _this$props2.rehireUserResourceId,
        favoritedConsultant = _this$props2.favoritedConsultant,
        newProjectDetails = _this$props2.newProjectDetails,
        userId = _this$props2.userId,
        projectTemplatesPath = _this$props2.projectTemplatesPath,
        hoursPerWeekPicklist = _this$props2.hoursPerWeekPicklist,
        showFullTimeOption = _this$props2.showFullTimeOption,
        projectTemplateId = _this$props2.projectTemplateId,
        jobDescriptionUpload = _this$props2.jobDescriptionUpload;
      var buttonProps = this.getButtonProps();
      return /*#__PURE__*/React.createElement(ProjectName, _extends({
        formType: "page",
        projectUrl: projectUrl,
        projectName: projectName || '',
        duplicationProjectResourceId: duplicationProjectResourceId,
        rehireUserResourceId: rehireUserResourceId,
        csrfToken: csrfToken,
        setProjectResourceId: this.handleSetProjectResourceId,
        projectResourceId: this.state.projectResourceId,
        getProjectDetails: this.getProjectDetails,
        isAdmin: isAdmin,
        companyPicklist: companyPicklist || [],
        companyId: companyId,
        favoritedConsultant: favoritedConsultant,
        newProjectDetails: newProjectDetails,
        userId: userId,
        projectTemplatesPath: projectTemplatesPath,
        hoursPerWeekPicklist: hoursPerWeekPicklist,
        showFullTimeOption: showFullTimeOption,
        projectTemplateId: projectTemplateId,
        jobDescriptionUpload: jobDescriptionUpload
      }, buttonProps));
    }
  }, {
    key: "renderExpertiseSection",
    value: function renderExpertiseSection() {
      var _this$props3 = this.props,
        csrfToken = _this$props3.csrfToken,
        jobDescriptionUpload = _this$props3.jobDescriptionUpload;
      var buttonProps = this.getButtonProps();
      return /*#__PURE__*/React.createElement(ProjectExpertise, _extends({
        formType: "page",
        csrfToken: csrfToken,
        projectResourceId: this.state.projectResourceId,
        getProjectDetails: this.getProjectDetails,
        jobDescriptionUpload: jobDescriptionUpload
      }, buttonProps));
    }
  }, {
    key: "renderExpertisePrioritySection",
    value: function renderExpertisePrioritySection() {
      var csrfToken = this.props.csrfToken;
      var buttonProps = this.getButtonProps();
      return /*#__PURE__*/React.createElement(ProjectExpertisePriority, _extends({
        formType: "page",
        csrfToken: csrfToken,
        projectResourceId: this.state.projectResourceId,
        getProjectDetails: this.getProjectDetails
      }, buttonProps));
    }
  }, {
    key: "renderResponsibilitiesSection",
    value: function renderResponsibilitiesSection() {
      var csrfToken = this.props.csrfToken;
      var buttonProps = this.getButtonProps();
      return /*#__PURE__*/React.createElement(ProjectResponsibilities, _extends({
        formType: "page",
        csrfToken: csrfToken,
        projectResourceId: this.state.projectResourceId,
        getProjectDetails: this.getProjectDetails
      }, buttonProps));
    }
  }, {
    key: "renderScopeSection",
    value: function renderScopeSection() {
      var csrfToken = this.props.csrfToken;
      var buttonProps = this.getButtonProps();
      return /*#__PURE__*/React.createElement(ProjectScope, _extends({
        formType: "page",
        csrfToken: csrfToken,
        projectResourceId: this.state.projectResourceId,
        getProjectDetails: this.getProjectDetails
      }, buttonProps));
    }
  }, {
    key: "renderBudgetLogisticsSection",
    value: function renderBudgetLogisticsSection() {
      var _this$props4 = this.props,
        csrfToken = _this$props4.csrfToken,
        showBackgroundCheck = _this$props4.showBackgroundCheck;
      var buttonProps = this.getButtonProps();
      return /*#__PURE__*/React.createElement(ProjectBudgetLogistics, _extends({
        formType: "page",
        csrfToken: csrfToken,
        projectResourceId: this.state.projectResourceId,
        getProjectDetails: this.getProjectDetails,
        showBackgroundCheck: showBackgroundCheck
      }, buttonProps));
    }
  }, {
    key: "renderReviewSection",
    value: function renderReviewSection() {
      var _this$props5 = this.props,
        projectUrl = _this$props5.projectUrl,
        csrfToken = _this$props5.csrfToken,
        showAddlRequirements = _this$props5.showAddlRequirements,
        isAdmin = _this$props5.isAdmin,
        projectTypes = _this$props5.projectTypes,
        userId = _this$props5.userId,
        homePath = _this$props5.homePath,
        showFullTimeOption = _this$props5.showFullTimeOption;
      var _this$state2 = this.state,
        projectResourceId = _this$state2.projectResourceId,
        step = _this$state2.step,
        steps = _this$state2.steps;
      return /*#__PURE__*/React.createElement(ProjectReview, {
        projectUrl: projectUrl,
        csrfToken: csrfToken,
        showAddlRequirements: showAddlRequirements,
        handleUpdateSection: this.handleUpdateSection,
        projectResourceId: projectResourceId,
        getProjectDetails: this.getProjectDetails,
        steps: steps,
        isAdmin: isAdmin,
        projectTypes: projectTypes,
        openAdminModal: step === 'admin',
        userId: userId,
        homePath: homePath,
        showFullTimeOption: showFullTimeOption
      });
    }
  }, {
    key: "renderSection",
    value: function renderSection() {
      var step = this.state.step;
      switch (step.replace(/%20/g, ' ')) {
        case 'start':
          return this.renderNameSection();
        case 'qualifications':
          return this.renderExpertiseSection();
        case 'expertise-priority':
          return this.renderExpertisePrioritySection();
        case 'description':
        case 'responsibilities':
          return this.renderResponsibilitiesSection();
        case 'scope':
          return this.renderScopeSection();
        case 'logistics':
        case 'budget ':
        case 'budget & logistics':
          return this.renderBudgetLogisticsSection();
        default:
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
        step = _this$state3.step,
        validatedStep = _this$state3.validatedStep,
        projectResourceId = _this$state3.projectResourceId;
      var _this$props6 = this.props,
        favoritedConsultantName = _this$props6.favoritedConsultantName,
        reviewProjectPath = _this$props6.reviewProjectPath,
        homePath = _this$props6.homePath,
        projectsPath = _this$props6.projectsPath;
      if (step === 'review' || step === 'admin') return this.renderReviewSection();
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ProjectDetailsNav, {
        isProjectNew: reviewProjectPath === null,
        displayExit: true,
        reviewPath: reviewProjectPath,
        homePath: homePath,
        projectsPath: projectsPath
      }), /*#__PURE__*/React.createElement("div", {
        className: "project-details-screen container-md"
      }, favoritedConsultantName && /*#__PURE__*/React.createElement(FeaturedProfileBanner, {
        consultantName: favoritedConsultantName
      }), /*#__PURE__*/React.createElement(NavBar, {
        activeSection: step,
        handleUpdateSection: this.handleUpdateSection,
        validatedStep: validatedStep,
        projectResourceId: projectResourceId
      }), /*#__PURE__*/React.createElement("div", {
        className: "edit-project-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "spacer m-0"
      }), this.renderSection())));
    }
  }]);
}(Component);
ProjectDetails.propTypes = {
  projectResourceId: PropTypes.string,
  projectUrl: PropTypes.string.isRequired,
  projectName: PropTypes.string,
  duplicationProjectResourceId: PropTypes.string,
  rehireUserResourceId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  step: PropTypes.string,
  isAdmin: PropTypes.bool,
  companyPicklist: PropTypes.arrayOf(PropTypes.shape({})),
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showAddlRequirements: PropTypes.bool,
  projectTypes: PropTypes.arrayOf(PropTypes.shape({})),
  returnToProjectPage: PropTypes.bool,
  validatedStep: PropTypes.string,
  favoritedConsultant: PropTypes.string,
  favoritedConsultantName: PropTypes.string,
  userId: PropTypes.string.isRequired,
  newProjectDetails: PropTypes.shape({}),
  projectTemplatesPath: PropTypes.string,
  hoursPerWeekPicklist: PropTypes.arrayOf(PropTypes.shape({})),
  reviewProjectPath: PropTypes.string,
  formType: PropTypes.string,
  homePath: PropTypes.string.isRequired,
  projectsPath: PropTypes.string.isRequired,
  showFullTimeOption: PropTypes.bool.isRequired,
  projectTemplateId: PropTypes.number,
  jobDescriptionUpload: PropTypes.bool,
  showBackgroundCheck: PropTypes.bool
};
ProjectDetails.defaultProps = {
  formType: 'page',
  projectResourceId: null,
  step: 'start',
  validatedStep: 'review',
  duplicationProjectResourceId: null,
  rehireUserResourceId: null,
  companyPicklist: [],
  isAdmin: false,
  companyId: null,
  projectName: null,
  showAddlRequirements: false,
  projectTypes: [],
  returnToProjectPage: false,
  favoritedConsultant: null,
  favoritedConsultantName: null,
  newProjectDetails: {},
  projectTemplatesPath: null,
  hoursPerWeekPicklist: [],
  reviewProjectPath: null,
  projectTemplateId: null,
  jobDescriptionUpload: false,
  showBackgroundCheck: false
};
export default ProjectDetails;